export const LOGIN = "/login";
export const SIGNUP = "/signup";

export const BASE = "/";
export const PROFILE = "/profile";
export const ATTENDANCE = "/attendance";

export const SITE = "/site";
export const ADD_SITE = "/site/add"
export const VIEW_SITE = "view/:siteId"
export const EDIT_SITE = "edit/:siteId";
export const BLOCK_EDIT_SITE = "/site/edit" //CONSTANT USED ONLY FOR BLOCKING EDIT SITES

export const CHECK_IN = "/attendance/check-in";
export const CHECK_OUT = "/attendance/check-out";
export const BACK_DATED = "/attendance/backdated";
export const ATTENDANCE_DASHBOARD_LINK = "/attendance";
export const ATTENDANCE_ACTION = "/attendance/action";
export const VIEW_DETAILED_PAGE = "/attendance/view_detailed/:id";
export const BACKDATED_APPROVAL = "/attendance/backdated-approval";

export const ADD_TASK = "/task/add";
export const TASK_PAGE = "/task"
export const VIEW_DETAILS = "view-details/:taskId";

export const ADD_BILL_LINK = "/add-bill";
export const LIST_BILLS = "/bills"
export const ADD_BILL = "/bills/add/:billType"
export const VIEW_BILL = "/bills/view/:billId"

export const USER_PAGE = "/users";
export const EDIT_USER = "/users/edit/:userId";
export const VIEW_USER = "/users/view/:userId";

export const DRIVE = "/drive/:type";

export const NOTIFICATIONS = "/notifications"
export const ESS = "/ess";

export const TRAINING = "/training";
export const CREATE_COURSE = "/training/add";
export const EDIT_COURSE = "/training/edit/:courseEditId";
export const LEARNING_COURSE = '/training/courses/:courseId'
export const TRAINING_COURSE = '/training/courses'
export const LEAVE_CALENDAR = '/leave-calendar';
export const LEAVE_REQUEST_LIST = '/leave-request';
export const ADD_LEAVE_REQUEST = '/leave-request/add';
export const VIEW_LEAVE_REQUEST = '/leave-request/view/:leaveRequestId';

export const LEAVE_APPROVALS = '/leave-approvals';
export const VIEW_LEAVE_APPROVALS = `/leave-approvals/view/:leaveRequestId`

export const LEAVE_SUMMARY_LIST = '/leave-summary';

export const LEAVE_CREDIT_DEBIT_LIST = '/leave-credit-debit';
export const ADD_LEAVE_CREDIT_DEBIT = '/leave-credit-debit/add';
export const VIEW_LEAVE_CREDIT_DEBIT = '/leave-credit-debit/view/:instanceId';

export const SALARY_MASTER = '/payroll';
export const ADD_SALARY_MASTER = '/payroll/add';
export const DETAIL_SALARY_MASTER = "/payroll/view/:payrollId"
export const SALARY_SLIP = '/salary-slip';
export const DETAIL_SALARY_SLIP = "/salary-slip/view/:slipId"
export const EDIT_SALARY_SLIP = "/salary-slip/edit/:slipId"

export const EMP_REFERRAL_LIST = '/employee-referrals';
export const VIEW_EMP_REFERRAL = '/employee-referrals/view/:instanceId';
export const ADD_EMP_REFERRAL = '/employee-referrals/add';

export const UNAUTHORIZED_ROUTES_MAPPING = {
  SITESTAFF: [
    SITE,
    ADD_SITE,
    BLOCK_EDIT_SITE,
    USER_PAGE
  ],
  INCHARGE: [
    ADD_SITE,
    BLOCK_EDIT_SITE,
    USER_PAGE
  ],
  PROJECT_INCHARGE: [
    ADD_SITE,
    BLOCK_EDIT_SITE,
    USER_PAGE
  ],
  ADMIN: [],
  DIRECTOR_MANAGEMENT: [],
};
